"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      id: null,
      info: {},
      genderDic: ['未知', '男', '女']
    };
  },
  created: function created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var data = {
        accountId: this.id
      };
      (0, _user.getUserInfo)(data).then(function (res) {
        _this.loading = false;
        if (res.data.errno == 0) {
          _this.info = res.data.data;
        }
      }).catch(function () {});
    }
  },
  components: {}
};